import { makeAutoObservable } from "mobx";
import { AttributeShelf } from "../AttributeShelf";

export class InputShelf<T> {
	public field: AttributeShelf<T>;

	constructor(initialValue: T) {
		this.field = new AttributeShelf(initialValue);

		makeAutoObservable(this);
	}

	public onChange = (value: T): void => {
		this.field.set(value);
	};
}
